import React from "react";
import "./footer.css";
import { HashLink } from "react-router-hash-link";
import { FaSquareWhatsapp } from "react-icons/fa6";

import { IoIosMail } from "react-icons/io";

const Footer = () => {
  return (
    <>
      <div id="Footer-Section" className="footer css-selectorFooter ">
        <div className="left-f">
          <h2>About Me:</h2>
          <br />
          <span>
            © 2022 - Full Stack Developer / Freelancer.
            <br /> <h2> Shahzaib Imran </h2>
          </span>
          <div className="left-contact">
            <p>
              <FaSquareWhatsapp className="whats-icon" />

              <span>
                <a
                  href="https://wa.me/+923216066007"
                  target="_blank"
                  rel="noreferrer"
                >
                  +92-321-6066007
                </a>
              </span>
            </p>
            <p>
              <IoIosMail className="mail-icon" />
              <span>
                <a
                  href="mailto:shahzaibimran219@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  shahzaibimran219@gmail.com
                </a>
              </span>
            </p>
          </div>
        </div>
        <br />
        <div className="list-f">
          <h2>Explore:</h2> <br />
          <ul>
            <li>
              <a href="/">Privacy Policy</a>
            </li>
            <li>
              <HashLink to="/#services">Services</HashLink>
            </li>
            <li>
              <HashLink to="/contact">Contact</HashLink>
            </li>
          </ul>
        </div>
        <br />
        <div className="contact-f">
          <h3>Follow Me:</h3> <br />
          <span>Let us be social:</span>
          <br /> <br />
          <div className="social">
            <a
              href="https://www.fiverr.com/sm37864"
              className="fa fa-fonticons"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
            </a>
            <a
              href="https://www.instagram.com/shahzaib.21_/"
              className="fa fa-instagram"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
            </a>
            <a
              href="https://github.com/shahzaibimran219"
              className="fa githubFooter fa-github"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
            </a>
            <a
              href="https://www.linkedin.com/in/shahzaib-imran-2002y/"
              className="fa fa-linkedin"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
